module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai508-4494ca5684f177e5d15ea216d93fb703.jpg";